import { useEffect } from "react";
import {
  useGetMostRecentReceiptQuery,
  useGetMostRecentBillQuery,
} from "../../redux/apiSlices/Bill.slice";
import { IBillListDTO } from "../../Interfaces/Bill";

interface UseMostRecentDocumentProps {
  mode: "receipts" | "bills";
  setClickedBill?: (bill: IBillListDTO) => void;
}

export const useMostRecentDocument = ({
  mode,
  setClickedBill,
}: UseMostRecentDocumentProps) => {
  const { data: mostRecentReceipt } = useGetMostRecentReceiptQuery();
  const { data: mostRecentBill } = useGetMostRecentBillQuery();

  useEffect(() => {
    if (mode === "receipts" && mostRecentReceipt && setClickedBill) {
      setClickedBill(mostRecentReceipt);
    }
    if (mode === "bills" && mostRecentBill && setClickedBill) {
      setClickedBill(mostRecentBill);
    }
  }, [mode, mostRecentReceipt, mostRecentBill, setClickedBill]);

  return {
    mostRecentReceipt,
    mostRecentBill,
  };
};
